import { useTranslation } from "react-i18next";
import { Button } from "@boligportal/bricks-ui";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { Link, useRouter } from "@tanstack/react-router";
import { AlertState } from "~/components/bricks/AlertState";

export const FallbackError = (_props: ErrorComponentProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const canGoBack = router.history.canGoBack();

  return (
    <AlertState
      className="h-full w-full items-center justify-center"
      description={t("errors.global_description")}
      headline={t("errors.global_headline")}
      renderPrimaryAction={() =>
        canGoBack ? (
          <Button onClick={() => router.history.back()}>
            {t("errors.global_action_go_back")}
          </Button>
        ) : (
          <Button
            asChild
            color="primary-administration"
          >
            <Link
              to="/"
              replace
            >
              {t("errors.global_action_start_over")}
            </Link>
          </Button>
        )
      }
    />
  );
};
